module.exports = __webpack_public_path__ + "img/20210906-1630913640403112.4f101515.png";